import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {Accordion, AccordionHeader, AccordionItem, AccordionPanel} from '@adv-mt/ui/accordion'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'
import {ACCORDION_HEADER_ICONS} from '../accordionHeaderIcons.js'
import BaseDrawer from '../BaseDrawer/index.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-includedExtrasDrawer`

const IncludedExtrasDrawer = ({onClose, optionalEquipment = []}) => {
  const {i18n} = useSuiContext()

  return (
    <BaseDrawer onClose={onClose} title={i18n.t('COMMON.DETAIL_EXTRAS_INCLUDED')}>
      <Accordion className={BASE_CLASS} openMultiple>
        {optionalEquipment.map((group, index) => (
          <AccordionItem key={index} value={String(index)}>
            <AccordionHeader {...ACCORDION_HEADER_ICONS}>{group.title}</AccordionHeader>
            <AccordionPanel className={`${BASE_CLASS}-panel`}>
              {(group.descriptions || []).map((description, itemIndex) => (
                <span className={`${BASE_CLASS}-item`} key={itemIndex}>
                  {typeof description === 'string' ? description : description.value}
                </span>
              ))}
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </BaseDrawer>
  )
}

IncludedExtrasDrawer.displayName = 'IncludedExtrasDrawer'
IncludedExtrasDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  optionalEquipment: PropTypes.arrayOf(
    PropTypes.shape({
      descriptions: PropTypes.array,
      title: PropTypes.string
    })
  )
}

export default IncludedExtrasDrawer
